import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from 'react';
import { Modal } from 'antd';
import { SchemaForm } from '../SchemaForm';
export const FreeModalForm = (props) => {
    const { formProps: { formRef: _formRef, ...formProps }, onOk: _onOk, onCancel: _onCancel, onCancelClear = true, ...modalProps } = props;
    const formRef = useRef();
    const ref = _formRef ?? formRef;
    const onOk = () => {
        ref.current?.validateFields().then(() => {
            ref.current?.submit();
        });
    };
    const onCancel = (e) => {
        if (onCancelClear) {
            ref.current?.resetFields();
        }
        _onCancel?.(e);
    };
    return (_jsx(Modal, { ...modalProps, onOk: onOk, onCancel: onCancel, children: _jsx(SchemaForm, { ...formProps, formRef: ref, onOk: _onOk, labelCol: { xs: { span: 24 }, sm: { span: 24 } }, wrapperCol: { xs: { span: 24 }, sm: { span: 24 } } }) }));
};
